import React from 'react';

import classNames from 'classnames';
import { ResponseItem, TaskTypeId } from '@bringg/types';
import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { DetailedCellProps } from '@bringg-frontend/monitoring';

import useOrderExplorerTranslations from '../../../../use-order-explorer-translations';

import styles from './order-tag-cell.module.scss';

const OrderTagCell = ({ row }: DetailedCellProps<ResponseItem>) => {
	const { collect } = useOrderExplorerTranslations();
	const task = getRootEnv().dashboardSdk.sdk.v2.tasks.get(row.id);

	if (task.task_type_id !== TaskTypeId.CLICK_AND_COLLECT) {
		return null;
	}

	const { way_points } = task;

	const orderUniqueDetails = way_points[0].ui_data || {};
	const { color, number } = orderUniqueDetails;

	return (
		<div className={styles.orderTag}>
			<div className={classNames(styles.pickupTag, styles.collect)}>{collect}</div>
			{color && number && (
				<div className={classNames(styles.pickupTag, styles.tagNumber)} style={{ background: color }}>
					{number}
				</div>
			)}
		</div>
	);
};

export default OrderTagCell;
